import React, { useState, useEffect, useMemo} from 'react';
import api from "../../services/api";
import { useTranslation } from 'react-i18next';

import TableFull from '../Shared/CommonTable/TableFull'

import { dateFormatter } from '../../utils/dateFormatter'
import Loading from '../Shared/Loading'

import styles from './OperatorActiveConsultations.module.scss'
import { recordLengthFormatter } from '../../utils/recordLengthFormatter'

export default function OperatorActiveConsultations() {
  const { t } = useTranslation();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {    
    loadConsultations();
  }, []);

  const loadConsultations = function () {
    api
      .get(`/operator/consultation/active/list`)
      .then((response) => {
        setData(response.data.items);
        setLoading(false);
      });
  }

  const columns = useMemo(
    () =>
      [       
        {
          header: t('consultation.operator.list.userName'),
          accessorKey: "user.displayName",
          enableColumnFilter: false,
        },
        {
          header: t('consultation.operator.list.ageYears'),
          accessorKey: "user.ageYears",
          enableColumnFilter: false,
        },
        {
          header: t('consultation.operator.list.length'),
          accessorKey: "userRecord.recordLengthSeconds",
          enableColumnFilter: false,
          cell: props => <span>{recordLengthFormatter(props.getValue())}</span>,
        },
        {
          header: t('consultation.operator.list.record'),
          accessorKey: "userRecord.displayName",
          enableColumnFilter: false,
        },
        {
          header: t('consultation.operator.list.requestDate'),
          accessorKey: "requestDate",
          enableColumnFilter: false,
          cell: props => <>{dateFormatter(props.getValue())}</>,
        }
      ],
    [t]
  );  

  if (loading)
    return <Loading />;

  return (
    <>
      <TableFull styles={styles} data={data} columns={columns} />
    </>
  );
}